import { Link } from 'react-router-dom';
import { SectionLabel, TiltCard } from '../components/Effects';
import { ArrowIcon, DiscordIcon } from '../components/Icons';

export function AboutPage() {
  const invite = import.meta.env.VITE_DISCORD_INVITE_URL || 'https://discord.gg/hAqvebcSh3';

  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="page-hero-bg" />
        <div className="page-hero-copy">
          <div className="eyebrow">
            <span /> CITIZEN ARCHIVE & CHRONICLE / ABOUT US
          </div>
          <h1>
            The Vision Behind<br />
            <em>Uge Appage SMP.</em>
          </h1>
          <p>
            From late-night banter between streamers to Sri Lanka's foremost player-driven
            Minecraft civilization, discover the creators, philosophy, and architectural ambition that define our world.
          </p>
          <div className="page-hero-actions">
            <a className="primary-btn discord" href={invite} target="_blank" rel="noreferrer">
              <DiscordIcon /> Join Our Community
            </a>
            <Link className="ghost-link" to="/journey">
              Explore Our Journey <ArrowIcon />
            </Link>
          </div>
        </div>
        <div className="constitution-seal">
          <img src="/assets/ugeappage-logo-zoomed.webp" alt="Uge Appage SMP Seal" />
          <span>EST. 2021</span>
          <b>VISION</b>
          <small>SOVEREIGN NATION</small>
        </div>
      </section>

      <section className="section-pad">
        <SectionLabel index="01">FOUNDING PHILOSOPHY</SectionLabel>
        <div className="split-heading" data-reveal>
          <h2>A World Forged<br /><em>By Real Hands.</em></h2>
          <p>
            We set out with one unwavering rule: no infinite shopkeepers, no pay-to-win kits, and no conjured wealth.
            Every single cobblestone, every rupee in circulation, and every industrial turbine began as human labor.
          </p>
        </div>

        <div className="feature-row">
          <TiltCard>
            <span>PLAYER SOVEREIGNTY</span>
            <h3>True Governance & Diplomacy</h3>
            <p>
              Two historic towns—Old Town and New Town—divided by ideology and mountains, yet united under one economy.
              Players govern districts, form alliances, write legal treaties, and enforce community justice.
            </p>
          </TiltCard>
          <TiltCard>
            <span>ENGINEERED ARCHITECTURE</span>
            <h3>No Cheap Hacks, Pure Craftsmanship</h3>
            <p>
              From the 2.6 km deepslate railway tunnel beneath Cherry Mountain to offshore industrial biosphere domes,
              our builds are meticulously designed to blend grand aesthetics with server performance.
            </p>
          </TiltCard>
          <TiltCard>
            <span>SRI LANKAN GAMING CULTURE</span>
            <h3>United Across Java & Bedrock</h3>
            <p>
              Sri Lankan gamers play on mobile phones, budget PCs, and high-end rigs alike.
              We bridged Java and Bedrock into one synchronized realm with custom physics parity and voice channels.
            </p>
          </TiltCard>
        </div>
      </section>

      <section className="section-pad dark-surface">
        <SectionLabel index="02">THE COUNCIL & LEADERSHIP</SectionLabel>
        <div className="split-heading" data-reveal>
          <h2>Custodians of<br /><em>the Sovereign Realm.</em></h2>
          <p>Meet the minds, builders, and developers keeping the clocks running, the banks solvent, and the servers online.</p>
        </div>

        <div className="leaders-grid" data-reveal>
          <article className="leader-card">
            <div className="leader-avatar-wrap">
              <img src="https://mc-heads.net/avatar/Jabuux/100" alt="Jabuu.x" />
              <span className="leader-role-tag founder">FOUNDER & CHIEF CREATOR</span>
            </div>
            <div className="leader-body">
              <h3>Jabuu.x</h3>
              <p>Streamer, pioneer, and visionary behind Uge Appage SMP. Guiding the server storyline, diplomatic rivalries, and community expansions.</p>
            </div>
          </article>

          <article className="leader-card">
            <div className="leader-avatar-wrap">
              <img src="https://mc-heads.net/avatar/HiruXGaming/100" alt="Hiru X Gaming" />
              <span className="leader-role-tag builder">LEGENDARY CREATOR & EXPLORER</span>
            </div>
            <div className="leader-body">
              <h3>Hiru X Gaming</h3>
              <p>Veteran explorer, chronicler of Uge Appage history, and master of frontier settlements from No Port City to New Town.</p>
            </div>
          </article>

          <article className="leader-card">
            <div className="leader-avatar-wrap">
              <img src="https://mc-heads.net/avatar/WJBiman/100" alt="WJ Biman" />
              <span className="leader-role-tag engineer">CHIEF ARCHITECT & DEVELOPER</span>
            </div>
            <div className="leader-body">
              <h3>WJ Biman</h3>
              <p>Systems architect, economic engineer, and bot developer. Crafting the 1B LKR banking infrastructure, custom web portals, and server automation.</p>
            </div>
          </article>
        </div>
      </section>

      <section className="section-pad rules-pledge">
        <div data-reveal>
          <img src="/assets/ugeappage-logo-zoomed.webp" alt="Uge Appage SMP" />
          <small>BECOME A CITIZEN</small>
          <h2>Write your chapter<br />in our history.</h2>
          <p>Join over a thousand citizens in our shared realm. Take your place in the living world.</p>
          <div className="pledge-actions">
            <Link className="primary-btn enchant" to="/">Return to Portal <ArrowIcon /></Link>
            <Link className="outline-link" to="/journey">View The Journey <ArrowIcon /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
